import { useMutation } from '@tanstack/react-query'

import { checkCoupon } from '../paymentsService'

export const useCheckCoupon = () => {
  return useMutation({ mutationFn: checkCoupon })
}
